import React from "react";
import photo from "../assets/newimage/first11.jpg";

function Features() {
  return (
    <section className="bg-[#CAD3D0] py-4 px-6 text-[#1A3C34]" id="services">
      <div className="max-w-7xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-6">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold leading-tight">
            Our Services
          </h2>
          {/* <p className="text-base text-gray-600 mb-2 mb-2 mt-4 max-w-2xl mx-auto">
            To provide truly transformative coaching, I leverage Nouriv's advanced capabilities. These features are designed to empower your experience and enhance the value of our work together.
          </p> */}
        </div>

        {/* Bottom Image (kept as is, consider replacing with a relevant image for premium features) */}
        {/* <div className="overflow-hidden shadow-lg max-w-4xl mx-auto">
          <img
            src={photo}
            alt="Premium coaching features" // Updated alt text
            className="w-full h-auto object-cover"
          />
        </div> */}

        {/* Feature Descriptions (replacing old icons/titles) */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 text-left mb-6 max-w-5xl mx-auto py-10">
          {/* Effortless Homework Submission */}
          <div className="bg-white p-6 rounded-lg shadow-md flex items-start space-x-4">
            <div>
              <h3 className="text-lg font-semibold mb-2">
               Plant Sitting and Health Checks
              </h3>
              <p className="text-sm text-gray-600 mb-2 mb-2">
                 A full plant checkup to prune, repot, and refresh your existing collection so it thrives again.
              </p>
              <a
                href="https://book.squareup.com/appointments/xxgm3rjcbdu4ud/location/LC274M19X7T68/services/474A67W5TVCL3BDLQQHOVL6I" // replace with your actual booking link
                className="text-[#1A3C34] font-semibold hover:underline"
              >
                Book Service
              </a>
            </div>
          </div>

          {/* Revisit Key Insights */}
          <div className="bg-white p-6 rounded-lg shadow-md flex items-start space-x-4">
            <div>
              <h3 className="text-lg font-semibold mb-2">New Plant Setup</h3>
              <p className="text-sm text-gray-600 mb-2">
                Want to add new plants but not sure where to start? We’ll help
                you choose the right plants for your space, set them up, and
                teach you how to care for them.
              </p>
              <a
                href="https://book.squareup.com/appointments/xxgm3rjcbdu4ud/location/LC274M19X7T68/services/PAED3LKAWGEPQM6EQHDZQKHO" // replace with your actual booking link
                className="text-[#1A3C34] font-semibold hover:underline"
              >
                Book Service
              </a>
            </div>
          </div>


          {/* NEW: Personalized Content Delivery */}
          <div className="bg-white p-6 rounded-lg shadow-md flex items-start space-x-4">
            <div>
              <h3 className="text-lg font-semibold mb-2">Plant Procurement</h3>
              <p className="text-sm text-gray-600 mb-2">
                Looking for the perfect new addition? We’ll source the
                healthiest plants for your home or office.
              </p>
              <a
                href="https://book.squareup.com/appointments/xxgm3rjcbdu4ud/location/LC274M19X7T68/services/4QX37I2HGLFFE2N3SRNSTUPK" // replace with your actual booking link
                className="text-[#1A3C34] font-semibold hover:underline"
              >
                Book Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Features;
